import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { logger } from '~portal/lib';
import { parseUsageSearch, type UsageSearchPatch, withSearch } from '~portal/lib/usage-overview';
import { UsageOverviewPage } from './-usage-overview';

/**
 * @desc The admin usage overview (H2-266). Every filter lives in the URL (`parseUsageSearch`), so a
 * view can be shared or bookmarked; the page itself is `UsageOverviewPage`.
 */
export const Route = createFileRoute('/_protected/admin/usage')({
  validateSearch: parseUsageSearch,
  component: AdminUsagePage,
});

function AdminUsagePage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const update = (patch: UsageSearchPatch) => {
    navigate({
      search: (prev) => withSearch(prev, patch),
      // Every control here (range, organisations, user, internal toggle) is in place.
      resetScroll: false,
    }).catch((err) => {
      logger.error('[AdminUsage] Navigation failed', {
        error: err instanceof Error ? err.message : String(err),
      });
    });
  };

  return <UsageOverviewPage search={search} onSearch={update} />;
}
